// When a masked entry is checked, a rule can carry its masks over to similar
// entries. A masked spot then matches any word, so a short fixed text around it
// catches unrelated entries ("Mail - NAME" also hits "Mail - Inbox"). Rules are
// therefore only generalized when enough fixed text frames them. Below that the
// mask only applies to the entry itself. In doubt fewer rules.
export const MIN_FIXED_RULE_CHARS = 25;

// Letters and digits outside the masks, e.g. "Open ticket reporting 22nd - New Version -" -> 31.
export function fixedTextLength(anonymized) {
  return String(anonymized || "")
    .replaceAll("<<<space>>>", " ")
    .replace(/<<<[^>]+>>>/g, "")
    .replace(/[^\p{L}\p{N}]/gu, "").length;
}

export function hasMasks(anonymized) {
  return /<<<(?!space>>>)[^>]+>>>/.test(String(anonymized || ""));
}

export function canGeneralizeRule(anonymized) {
  return !hasMasks(anonymized) || fixedTextLength(anonymized) >= MIN_FIXED_RULE_CHARS;
}

// Only what the user checked is preselected: the entry itself and, for a group,
// its members. Every further match has to be ticked on purpose.
export function withOnlySourceSelected(preview, checkedIds = []) {
  if (!preview?.candidates) return preview;
  const checked = new Set([preview.source_id, ...checkedIds].map(String));
  return {
    ...preview,
    candidates: preview.candidates.map((candidate) => ({
      ...candidate,
      selected: checked.has(String(candidate.id)),
    })),
  };
}
